/* Shoppingooo QA only: recover a checkout button left disabled by OrderHub's loading shell.
   Does NOT bypass form validation, server price checks, or an in-flight order submit. */
(() => {
  'use strict';
  const SELECTOR = '.oh-egypt-order[data-checkout-mode="cart"]';
  const READY_LABEL = /^(?:Confirm order|تأكيد الطلب)(?:\s*[—–-]\s*.*)?$/i;
  const supportsReadyLines = (root) => {
    const lines = root.querySelector('[data-lines]');
    const total = root.querySelector('[data-total]');
    return Boolean(lines?.querySelector('.oh-egypt-order__line')
      && /[0-9٠-٩]/.test(total?.textContent || ''));
  };
  const attemptRecovery = (root) => {
    const app = root.querySelector('[data-app]');
    const form = root.querySelector('[data-form]');
    const submit = root.querySelector('[data-submit]');
    if (!submit || !form || !app || root.hidden || app.hidden || form.hidden) return;
    if (root.dataset.loaded !== '1' || !supportsReadyLines(root)) return;
    if (root.classList.contains('is-confirming')) return;
    if (root.querySelector('[data-oh-staging-cod-loading], [data-oh-staging-cod-skeleton]')) return;
    if (root.querySelector('[data-status]')?.hidden === false) return;
    if (root.querySelector('[data-result]')?.hidden === false) return;
    if (submit.dataset.ohLoadingDisabled === '1') return;
    if (!READY_LABEL.test((submit.textContent || '').trim())) return;
    const paid = form.querySelector('input[name="paymentMethod"]:checked');
    if (!paid) return;
    if (!submit.disabled && !root.querySelector('[data-sticky-submit]:disabled')) return;
    // OrderHub's existing submit listener still validates all required fields
    // and revalidates the cart with its server before creating any order.
    submit.disabled = false;
    const sticky = root.querySelector('[data-sticky-submit]');
    if (sticky) sticky.disabled = false;
    root.dataset.shoppingoooConfirmRecovered = '1';
  };
  const attach = (root) => {
    if (!root || root.dataset.shoppingoooConfirmGuard === '1') return;
    root.dataset.shoppingoooConfirmGuard = '1';
    let queued = false;
    const tick = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        if (root.isConnected) attemptRecovery(root);
      });
    };
    const observer = new MutationObserver(tick);
    observer.observe(root, {
      subtree: true, childList: true, characterData: true, attributes: true,
      attributeFilter: ['disabled', 'hidden', 'class', 'data-oh-loading-disabled']
    });
    tick();
    root.addEventListener('change', tick);
    root.addEventListener('input', tick);
  };
  const boot = () => {
    const existing = document.querySelector(SELECTOR);
    if (existing) return attach(existing);
    const watcher = new MutationObserver(() => {
      const root = document.querySelector(SELECTOR);
      if (!root) return;
      watcher.disconnect();
      attach(root);
    });
    watcher.observe(document.documentElement, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else boot();
})();